// R-AdminSensor-Open-As-Company — Option A frontend 평문 POST 부트스트랩.
//
// AdminSensor 의 업체명 클릭 → 새 탭 `/__open-as-company?companySeq=<N>&companyName=<name>` 로 진입.
// AdminCompanyService.getList() 로 companySeq → userName 매핑 → 통일 PW (env) 로 POST /login → /dashboard.
//
// 보안 모델: admin 페이지 접근자 = 관리자 라는 운영 정책 위에서만 안전.
// 통일 PW 는 process.env.REACT_APP_UNIFIED_PW 에서만 읽음 — 소스에 평문 리터럴 0건.

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminCompanyService } from '../../api/admin/AdminCompanyService';
import { useUserAPI } from '../../api/user/useUserAPI';

const AutoLoginAsCompany = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userAPI = useUserAPI();
  const [phase, setPhase] = useState('loading'); // 'loading' | 'badRequest' | 'notFound' | 'loginFailed'
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const seqRaw = params.get('companySeq');
    const nameParam = params.get('companyName') || '';
    setCompanyName(nameParam);

    if (!seqRaw || !/^\d+$/.test(seqRaw)) {
      setPhase('badRequest');
      return;
    }
    const seq = Number(seqRaw);

    let cancelled = false;
    (async () => {
      try {
        const list = await AdminCompanyService.getList();
        if (cancelled) return;
        const row = (list || []).find((c) => c.companySeq === seq);
        if (!row || !row.userName) {
          setPhase('notFound');
          return;
        }
        await userAPI.login({
          username: row.userName,
          password: process.env.REACT_APP_UNIFIED_PW,
        });
        if (cancelled) return;
        navigate('/dashboard', { replace: true });
      } catch (e) {
        if (!cancelled) setPhase('loginFailed');
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  if (phase === 'loading') {
    return (
      <div className="auto-login-bootstrap" style={{ padding: '40px', textAlign: 'center' }}>
        자동 로그인 중…{companyName ? ` (${companyName})` : ''}
      </div>
    );
  }
  if (phase === 'badRequest') {
    return (
      <div className="auto-login-error" style={{ padding: '40px', textAlign: 'center' }}>
        잘못된 요청 — companySeq 가 누락되었거나 올바르지 않습니다.
      </div>
    );
  }
  if (phase === 'notFound') {
    return (
      <div className="auto-login-error" style={{ padding: '40px', textAlign: 'center' }}>
        업체를 찾을 수 없습니다.
      </div>
    );
  }
  return (
    <div className="auto-login-error" style={{ padding: '40px', textAlign: 'center' }}>
      로그인 실패 — 관리자에게 문의하세요.
    </div>
  );
};

export default AutoLoginAsCompany;
